// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"71912240","485":"71912240","807":"ca17dbd4"}[chunkId] + ".chunk.css";
};